module.exports = __webpack_public_path__ + "static/media/11.03ca91bc.png";